export class Paginado {
    
        constructor(resultCount: number, options?: object) {
            this.page = 0;
            this.rowsPerPage = 10;
            this.resultCount = resultCount;
            this.options = options || this.options;
        }
        resultCount: number;
        page: number = 0;
        rowsPerPage: number = 10;
        options: any = {
            optRowsPerPage: [5, 10, 25, 50, 100]
        }
    
        from(): number {
            return this.page * this.rowsPerPage;
        }
        to(): number {
            var hasta = this.from() + this.rowsPerPage;
            return hasta <= this.resultCount ? hasta : this.resultCount;
        }
        next() {
            if (this.to() < this.resultCount) {
                this.page++;
            }
        }
        prev() {
            if (this.from() >= this.rowsPerPage) {
                this.page--;
            }
        }
        setPage(page: number) {
            page--;
            if (page < this.resultCount / this.rowsPerPage) {
                this.page = page;
            }
        }
    }
    